<template>
<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 62 (91390) - https://sketch.com -->
    <title>arrow-video</title>
    <desc>Created with Sketch.</desc>
    <g id="video-and-cobrowsing" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round">
        <g id="Artboard-Copy" transform="translate(-791.000000, -470.000000)" stroke="#ffffff" stroke-width="1.5">
            <path d="M792.5,471 L803,471 C803.552285,471 804,471.447715 804,472 L804,482.5 C804,482.776142 803.776142,483 803.5,483 C803.223858,483 803,482.776142 803,482.5 L803,473 C803,472.447715 802.552285,472 802,472 L792.5,472 C792.223858,472 792,471.776142 792,471.5 C792,471.223858 792.223858,471 792.5,471 Z" id="arrow-video"></path>
        </g>
    </g>
</svg>
</template>
